import $ from "jquery";
import {CustomerEntity, PrintModel} from "../Api/Types";
import {BaseHandler} from "./BaseHandler";
import {Popup} from "../Popups/Popup";

export class ManageCustomerEntitiesHandler extends BaseHandler {

    private print_models: PrintModel[];

    private build_customer_entity(element: JQuery, customer: CustomerEntity) {
        element.attr("data-id", customer.customer_entity_id);

        element.find('[data-content-type="name"]').text(customer.name);
        element.find('[data-content-type="formal_name"]').text(customer.formal_name);
        element.find('[data-content-type="bank_name"]').text(customer.bank_name);
        element.find('[data-content-type="owner"]').text(customer.owner);
        element.find('[data-content-type="bic"]').text(customer.bic);
        element.find('[data-content-type="iban"]').text(customer.iban);
        element.find('[data-content-type="enable_online_payments"]').prop("checked", customer.enable_online_payments);

        if (customer.initialized) {
            element.find('[data-when="initialized"]').show();
            element.find('[data-when="not_initialized"]').hide();
        } else {
            element.find('[data-when="initialized"]').hide();
            element.find('[data-when="not_initialized"]').show();
        }

        const modelTitle = this.print_models.find(pm => pm.print_model_id === customer.ref_print_model_id)?.title || '';
        element.find('.model-input').val(modelTitle);
        element.find('[data-content-type="model_to_use"]').text(modelTitle);
    }

    public override handle() {
        super.handle();

        this.client.get_print_models().ew_done(print_model_response => {
            this.print_models = print_model_response.print_models;

            const data_list = $("#print-model-list").html("");
            for (const print_model of this.print_models) {
                $("<option>")
                    .val(print_model.title)
                    .attr("data-id", print_model.print_model_id)
                    .appendTo(data_list);
            }

            this.client.get_customer_entities().ew_done(customers => {
                const container = $("#page-container").empty();
                for (const customer of customers) {
                    const item = this.get_template_jquery("customer-entry");
                    this.build_customer_entity(item, customer);
                    container.append(item);
                }

                this.attachEventHandlers();
            });
        });
    }

    private attachEventHandlers() {
        $(document.body).on("click", '[data-action="save"]', e => {
            const box = $(e.currentTarget).closest(".customer-entry");
            box.find('div:has(input) > [data-action="edit"]').trigger("click");

            const bank_name = box.find('[data-content-type="bank_name"]').text() || null;
            const formal_name = box.find('[data-content-type="formal_name"]').text() || null;
            const owner = box.find('[data-content-type="owner"]').text() || null;
            const bic = box.find('[data-content-type="bic"]').text() || null;
            const iban = box.find('[data-content-type="iban"]').text() || null;
            const enable_online_payments: boolean = box.find('[data-content-type="enable_online_payments"]').prop("checked");

            const id = Number(box.attr("data-id"));

            const modelVal = box.find('.model-input').val()?.toString().trim() || '';
            const selectedModel = this.print_models.find(pm => pm.title.toLowerCase() === modelVal.toLowerCase());
            const print_model_id = selectedModel?.print_model_id ?? null;

            this.client.update_customer_entity(id, bank_name, formal_name, owner, bic, iban, enable_online_payments, print_model_id).ew_done((x) => {
                this.build_customer_entity(box, x)
                const t = Popup.DefaultErrorInject('template aggiornato correttamente', "Success", false);
                const set_animation = (d: JQuery.Deferred<any>) => {
                    d.done(() => {
                        alert();
                        t.popup.Remove();
                    });

                    d.always((x: JQuery.Deferred<any>) => set_animation(x));
                };

                set_animation(t.deferred);
            })
        });

        $(document.body).on("click", '[data-action="edit"]', e => {
            const event_target = $(e.currentTarget);
            const wp_edit_target = event_target.parent().find('[data-role="edit-target"]');
            const edit_target = wp_edit_target[0];

            if (edit_target.tagName === "SPAN") {
                const inp = $(document.createElement("input"));
                inp.prop("type", "text");
                inp.attr("data-role", "edit-target");
                inp.attr("data-content-type", wp_edit_target.attr("data-content-type"));
                inp.val(wp_edit_target.text());

                edit_target.replaceWith(inp[0]);
                inp[0].focus();
            } else {
                const span = $(document.createElement("span"));
                span.attr("data-role", "edit-target");
                span.attr("data-content-type", wp_edit_target.attr("data-content-type"));
                span.text(wp_edit_target.val().toString());

                edit_target.replaceWith(span[0]);
            }
        });
    }
}